import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_DataPreparationSimple = _resolveComponent("DataPreparationSimple")
  const _component_DataPreparationFilter = _resolveComponent("DataPreparationFilter")
  const _component_DataPreparationSplit = _resolveComponent("DataPreparationSplit")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary dataPreparationDialog",
    visible: _ctx.transformation && _ctx.transformation.type != 'calculatedField',
    header: (_ctx.localCopy && _ctx.localCopy.type ? _ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + _ctx.localCopy.name + '.label') + ' - ' : '') + _ctx.$t('managers.workspaceManagement.dataPreparation.parametersConfiguration'),
    closable: false,
    modal: "",
    breakpoints: { '960px': '75vw', '640px': '100vw' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button thirdButton",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.resetAndClose
      }, null, 8, ["label", "onClick"]),
      (!_ctx.readOnly)
        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--primary",
            onClick: _ctx.handleTransformation
          }, null, 8, ["onClick"])), [
            [_directive_t, 'common.apply']
          ])
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.localCopy && _ctx.localCopy.description)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "info",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.localCopy.description)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.localCopy.type === 'simple')
        ? (_openBlock(), _createBlock(_component_DataPreparationSimple, {
            key: 1,
            transformation: _ctx.localCopy,
            "onUpdate:transformation": _ctx.updateLocalCopy,
            columns: _ctx.columns,
            col: _ctx.col,
            readOnly: _ctx.readOnly
          }, null, 8, ["transformation", "onUpdate:transformation", "columns", "col", "readOnly"]))
        : _createCommentVNode("", true),
      (_ctx.localCopy.type === 'filter')
        ? (_openBlock(), _createBlock(_component_DataPreparationFilter, {
            key: 2,
            transformation: _ctx.localCopy,
            "onUpdate:transformation": _ctx.updateLocalCopy,
            columns: _ctx.columns,
            col: _ctx.col,
            readOnly: _ctx.readOnly
          }, null, 8, ["transformation", "onUpdate:transformation", "columns", "col", "readOnly"]))
        : _createCommentVNode("", true),
      (_ctx.localCopy.type === 'split')
        ? (_openBlock(), _createBlock(_component_DataPreparationSplit, {
            key: 3,
            transformation: _ctx.localCopy,
            "onUpdate:transformation": _ctx.updateLocalCopy,
            columns: _ctx.columns,
            col: _ctx.col,
            readOnly: _ctx.readOnly
          }, null, 8, ["transformation", "onUpdate:transformation", "columns", "col", "readOnly"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}